export enum PostHogFeatureFlags {
  CustomerSupportReinstateDirectDebit = 'customer-support-reinstate-direct-debit',
}
